import { LegalLayout, Block } from "../components/LegalLayout";
import { CONTACT, WHATSAPP_MAIN_LINK } from "../data";

export default function Impressum() {
  return (
    <LegalLayout title="Impressum">
      <Block heading="Angaben gemäß § 5 TMG">
        <p>{CONTACT.company}</p>
        <p>{CONTACT.address}</p>
      </Block>

      <Block heading="Vertreten durch">
        <p>{CONTACT.owner}</p>
      </Block>

      <Block heading="Kontakt">
        <p>Telefon: {CONTACT.phone}</p>
        <p>E-Mail: {CONTACT.email}</p>
        <p>WhatsApp: <a href={WHATSAPP_MAIN_LINK} target="_blank" rel="noopener noreferrer" className="text-[#60A5FA] underline">Direkt-Chat öffnen</a></p>
      </Block>

      <Block heading="Umsatzsteuer-ID">
        <p>Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz: {CONTACT.taxId}</p>
      </Block>

      <Block heading="EU-Streitschlichtung">
        <p>
          Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
          <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="text-[#60A5FA] underline">
            https://ec.europa.eu/consumers/odr
          </a>
          . Unsere E-Mail-Adresse finden Sie oben im Impressum.
        </p>
      </Block>

      <Block heading="Haftung für Inhalte">
        <p>
          Als Diensteanbieter sind wir gemäß § 5 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen
          verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder
          gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige
          Tätigkeit hinweisen.
        </p>
      </Block>

      <Block heading="Haftung für Links">
        <p>
          Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb
          können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets
          der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
        </p>
      </Block>

      <Block heading="Urheberrecht">
        <p>
          Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen
          Urheberrecht. Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des
          Urheberrechts bedürfen der schriftlichen Zustimmung des jeweiligen Autors.
        </p>
      </Block>
    </LegalLayout>
  );
}
